
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/youtube-to-flashcards",
      function () {
        return require("private-next-pages/youtube-to-flashcards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/youtube-to-flashcards"])
      });
    }
  